export const enum ORDER_STATUS {
  DeHaatCancelled = 'DEHAAT_CANCELLED',
  Delivered = 'DELIVERED',
  DeliveryFailed = 'FAILED_DELIVERY',
  OutForDelivery = 'OUT_FOR_DELIVERY',
  Pending = 'PENDING',
  ReadyForDelivery = 'READY_FOR_DELIVERY',
  UserCancelled = 'USER_CANCELLED',
  VendorCancelled = 'VENDOR_CANCELLED',
  VendorConfirmed = 'VENDOR_CONFIRMED',
  PreOrder = 'PRE_ORDER',
  Success = 'SUCCESS',
  PaymentFailed = 'PAYMENT_FAILED',
  Failed = 'FAILED',
  OrderFailed = 'ORDER_FAILED',
  Shipped = 'SHIPPED',
  ReturnToOrigin = 'RETURN_TO_ORIGIN',
}

export const enum ORDER_TYPE {
  OFFLINE_PICKUP = 'OFFLINE_PICKUP',
  DOORSTEP = 'DOORSTEP',
  SELF_PICKUP = 'SELF_PICKUP',
}
